import { render } from "../views/card.html?vue&type=template&id=5245d21c&ts=true&external"
import script from "../scripts/card.ts?vue&type=script&lang=ts&external"
export * from "../scripts/card.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5245d21c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5245d21c', __exports__)) {
    api.reload('5245d21c', __exports__)
  }
  
  module.hot.accept("../views/card.html?vue&type=template&id=5245d21c&ts=true&external", () => {
    api.rerender('5245d21c', render)
  })

}


export default __exports__